export const getMockData = () => [
  {
    'id': 1,
    'first_name': 'Lyell',
    'last_name': 'Kettlestringe',
    'email': 'lkettlestringe0@studiopress.com',
    'birth_date': '6/16/2022',
    'gender': 'Male',
    'catch_phrase': 'Open-architected empowering interface'
  }, {
    'id': 2,
    'first_name': 'Remington',
    'last_name': 'Kilbride',
    'email': 'rkilbride1@yandex.ru',
    'birth_date': '6/10/2022',
    'gender': 'Male',
    'catch_phrase': 'Reverse-engineered multi-state secured line'
  }, {
    'id': 3,
    'first_name': 'Richard',
    'last_name': 'Caldero',
    'email': 'rcaldero2@yellowpages.com',
    'birth_date': '1/10/2023',
    'gender': 'Male',
    'catch_phrase': 'Public-key solution-oriented hierarchy'
  }, {
    'id': 4,
    'first_name': 'Beale',
    'last_name': 'Nichol',
    'email': 'bnichol3@mit.edu',
    'birth_date': '2/17/2022',
    'gender': 'Male',
    'catch_phrase': 'Front-line demand-driven approach'
  }, {
    'id': 5,
    'first_name': 'Toddie',
    'last_name': 'Nesbeth',
    'email': 'tnesbeth4@alibaba.com',
    'birth_date': '1/16/2023',
    'gender': 'Male',
    'catch_phrase': 'Persevering local frame'
  }
];

export const getMockColumns = () => [
  { 'field': 'first_name', 'headerName': 'Imię' },
  { 'field': 'last_name', 'headerName': 'Nazwisko' },
  { 'field': 'email', 'headerName': 'Email' },
  { 'field': 'gender', 'headerName': 'Płeć' },
  { 'field': 'birth_date', 'headerName': 'Data urodzenia' },
  { 'field': 'catch_phrase', 'headerName': 'Catch phrase' }
];
